import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { ButtonComponent } from '../../../forms/button/button.component';
import {
  slideInLeftOnEnterAnimation,
  slideOutLeftOnLeaveAnimation,
  fadeInOnEnterAnimation,
  fadeOutOnLeaveAnimation
} from '../../../animations/index';

@Component({
    selector: 'app-sidenav-cabinet',
    templateUrl: './sidenav.component.html',
    styleUrl: './sidenav.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: [ButtonComponent],
    animations: [
        slideInLeftOnEnterAnimation({ duration: 300 }),
        slideOutLeftOnLeaveAnimation({ duration: 300 }),
        fadeInOnEnterAnimation({ duration: 200 }),
        fadeOutOnLeaveAnimation({ duration: 200 })
    ],
    host: {
        '[class.mobile-open]': 'isOpen()'
    }
})
export class SidenavCabinetComponent {
  isCollapsed = input<boolean>(false);
  isOpen = input<boolean>(false);
  toggleSidebar = output<void>();
  closeSidebar = output<void>();

  // For mobile, always show expanded (not collapsed)
  get effectiveCollapsedState(): boolean {
    // On mobile, never show collapsed state
    if (window.innerWidth < 1024) {
      return false;
    }
    // On desktop, use the actual collapsed state
    return this.isCollapsed();
  }

  onToggleSidebar(): void {
    this.toggleSidebar.emit();
  }

  onCloseSidebar(): void {
    this.closeSidebar.emit();
  }
}
